function getTrackUxConfig(config) {
  if (!config.projectId || !config.publicKey || !config.endpoint) {
    return null
  }

  return {
    projectId: config.projectId,
    publicKey: config.publicKey,
    endpoint: config.endpoint,
    environment: config.environment ?? 'development',
    debug: config.debug ?? process.env.NODE_ENV !== 'production',
    autoCapture: {
      pageViews: false,
      clicks: false,
      behavior: true,
      forms: false,
      scrollDepth: false,
    },
  }
}

let trackUxModulePromise

function loadTrackUxModule() {
  if (!trackUxModulePromise) {
    trackUxModulePromise = import('trackux')
  }

  return trackUxModulePromise
}

export function createTrackUxHandler(config) {
  let initialized = false
  let trackUxModule = null

  return {
    name: 'trackux',
    async initialize() {
      if (typeof window === 'undefined' || initialized) return

      const trackUxConfig = getTrackUxConfig(config)
      if (!trackUxConfig) return

      trackUxModule = await loadTrackUxModule()
      trackUxModule.init(trackUxConfig)
      initialized = true
    },
    async handle(event) {
      if (typeof window === 'undefined') return
      if (!initialized) {
        await this.initialize()
      }
      if (!initialized) return

      trackUxModule.track(event.name, event.properties)
    },
    async flush() {
      if (!initialized) return Promise.resolve()
      return trackUxModule.flush()
    },
  }
}
